import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '0 24px', background: '#FAFBFA' }}>
      <div style={{ width: 64, height: 64, borderRadius: 16, background: '#85BB65', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 32, boxShadow: '0 4px 20px rgba(133,187,101,0.3)' }}>
        <span style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, fontSize: 28, color: '#fff' }}>K</span>
      </div>
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#F0F7EB', border: '1px solid #C8E0B4', borderRadius: 999, padding: '6px 16px', marginBottom: 24 }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#85BB65', display: 'inline-block', animation: 'pulse 1.5s ease-in-out infinite' }} />
        <span style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 12, color: '#5E9444', letterSpacing: '0.08em', textTransform: 'uppercase' }}>In Development</span>
      </div>
      <h2 style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, fontSize: 'clamp(24px, 5vw, 36px)', color: '#1A1E1A', margin: '0 0 16px', letterSpacing: '-0.02em' }}>
        This page is coming soon
      </h2>
      <p style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 15, color: '#8A948A', maxWidth: 400, lineHeight: 1.8, marginBottom: 40 }}>
        We're building something great. The Korunto platform is growing — check back soon or head back home to learn more.
      </p>
      <Link to="/" style={{ padding: '13px 32px', borderRadius: 10, background: '#85BB65', color: '#fff', fontFamily: "'Raleway', sans-serif", fontWeight: 700, fontSize: 14, textDecoration: 'none', boxShadow: '0 4px 16px rgba(133,187,101,0.3)' }}>
        Back to Home
      </Link>
      <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }`}</style>
    </div>
  );
}
